import { fontSize } from '../../../';
import ChartFilterGroupCard from '../ChartFilterGroupCard';
import { fieldProps, groupProp } from '../../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { useDispatch } from 'react-redux';
import { IChartFIlter, ISyncFilterPayload } from '../interfaces';
import FetchData from '../../ServerCall/FetchData';
import {
  setLastModifiedFilter,
  setOptionsAndSelections,
  updateChartFilterRightGroupsFilters,
} from '../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
// These imports are needed for mapStateToProps and mapDispatchToProps. Can be removed if ChartFilterGroupCard don't use them(or use states using useSelector hooks and dispatch function).

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  updateChartFilterGroupsFilters,
  updateChartFilterGroupsCollapsed,
  updateChartFilterGroupsName,
} from '../../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { ChartPropertiesStateProps } from '../../../redux/ChartPoperties/ChartPropertiesInterfaces';
import { ChartFilterGroupStateProps } from '../../../redux/ChartFilterGroup/ChartFilterGroupInterface';
import {
  deleteDashBoardSelectedTabTiles,
  updateDashBoardSelectedTabTiles,
} from '../../../redux/DashBoardFilterGroup/DashBoardFilterGroupAction';
import { TileRibbonStateProps } from '../../../Components/TabsAndTiles/TileRibbonInterfaces';
import { SetModifyOptions } from '../../../redux/ChartPoperties/ChartControlsActions';

interface Props {
  propKey: string;
  group: groupProp;
  fromDashboard: boolean;
  link: string;

  color?: string;
  backgroundColor?: string;
}

/**
 * rendered by ChartFilterGroups.tsx
 * @returns ChartFilterGroupCard and a text conditionally.
 */
const FilterGroupContent = ({
  propKey,
  group,
  fromDashboard,
  link,
  color,
  backgroundColor,
}: Props) => {
  const { tabTileProps, token, groups } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
    token: state.isLogged.accessToken,
    groups: state.chartFilterGroup.groups,
  }));

  const dispatch = useDispatch();

  const dsDetails = tabTileProps.selectedDataSetList.find(
    (dataset: any) => dataset.id === group.dsIdForGroup,
  );

  async function syncFilterDataFetch(calledByFilter: IChartFIlter, isLastModified?: boolean) {
    if (!group.syncFilter) return;

    const filters = group.filters;
    const datasetId = group.dsIdForGroup;
    const lastModifiedFilterUid = isLastModified
      ? calledByFilter.uId
      : groups[group.id].lastModifiedFilterUid;

    if (!lastModifiedFilterUid || !filters || filters?.length < 2) return;

    let url = '';

    if (link && link !== '') {
      url = `open-link/sync-filter-options?datasetid=${datasetId}&${
        dsDetails.isFlatFileData ? '' : `dbconnectionid=${dsDetails.connectionId}`
      }&linkId=${link}`;
    } else {
      url = `sync-filter-options?datasetid=${datasetId}&${
        dsDetails.isFlatFileData ? '' : `dbconnectionid=${dsDetails.connectionId}`
      }`;
    }
    if (link && link !== '') {
      url = `open-link/sync-filter-options?datasetid=${datasetId}&${
        dsDetails.isFlatFileData ? '' : `dbconnectionid=${dsDetails.connectionId}`
      }&linkId=${link}`;
    } else {
      url = `sync-filter-options?datasetid=${datasetId}&${
        dsDetails.isFlatFileData ? '' : `dbconnectionid=${dsDetails.connectionId}`
      }`;
    }

    let payload: ISyncFilterPayload[] = [];
    let invalidFilter = false;
    let hasAtLeastOnePickList = false;
    type TDuplicateFieldTrack = {
      uid: string;
      fieldName: string;
      modifiedName: string;
      userSelection: any[];
    };
    const duplicateFieldTracker: TDuplicateFieldTrack[] = [];
    function getModifiedName(fieldName: string) {
      const duplicates = duplicateFieldTracker.filter(
        (item: TDuplicateFieldTrack) => item.fieldName === fieldName,
      );
      if (duplicates.length > 1) return `${fieldName}_${duplicates.length + 1}`;
      return fieldName;
    }
    filters.every((filter: IChartFIlter, idx: number) => {
      const obj = syncFilterPayloadPipe(
        filter.uId === calledByFilter.uId ? calledByFilter : filter,
        lastModifiedFilterUid,
      );
      if (obj) {
        payload.push(obj);
        const fieldTypeOption =
          filter.uId === calledByFilter.uId
            ? calledByFilter.fieldtypeoption
            : filter.fieldtypeoption;

        if (fieldTypeOption === 'Pick List') {
          const userSelection =
            filter.uId === calledByFilter.uId ? calledByFilter.userSelection : filter.userSelection;
          duplicateFieldTracker.push({
            uid: filter.uId,
            fieldName: filter.fieldname,
            modifiedName: getModifiedName(filter.fieldname),
            userSelection: userSelection ?? [],
          });
          hasAtLeastOnePickList = true;
        }
        return true;
      } else {
        invalidFilter = true;
        return false;
      }
    });

    if (invalidFilter || !hasAtLeastOnePickList) return;
    const res = await FetchData({
      checkToken: link === '',
      method: 'POST',
      url: url,
      requestType: 'withData',
      headers:
        link && link !== ''
          ? { 'Content-Type': 'application/json', 'X-TENANT-ID': 'community' }
          : {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
      data: payload,
    });
    if (!res.status) return;
    dispatch(updateChartFilterRightGroupsFilters(group.id, calledByFilter));
    duplicateFieldTracker.forEach((item: TDuplicateFieldTrack) => {
      if (res.data[item.modifiedName]) {
        let vals = res.data[item.modifiedName];
        if (vals.length > 0) {
          vals = vals.map((value: any) => {
            return value !== null
              ? typeof value === 'boolean'
                ? value
                  ? 'True'
                  : 'False' // Convert boolean to string
                : value
              : '(Blank)';
          });
        }
        const options =
          vals.length > 0
            ? [...new Set(['(All)', ...vals, ...item.userSelection])]
            : item.userSelection.length > 0
              ? [...new Set(['(All)', ...item.userSelection])]
              : [];
        const allSelected =
          options.length > 1 &&
          options.filter((opt) => opt !== '(All)').every((opt) => item.userSelection.includes(opt));

        const finalSelection = allSelected
          ? [...new Set(['(All)', ...item.userSelection])]
          : item.userSelection.filter((opt) => opt !== '(All)');
        dispatch(setOptionsAndSelections(group.id, options, finalSelection, item.uid));
        dispatch(setLastModifiedFilter(group.id, item.uid));
      }
    });

    dispatch(setLastModifiedFilter(group.id, calledByFilter.uId));
    dispatch(SetModifyOptions(propKey, 'filter_group', `${group.id}_${calledByFilter.uId}`));
  }

  function syncFilterPayloadPipe(
    filter: IChartFIlter,
    lastModifiedFilter: string,
  ): ISyncFilterPayload {
    // obj.
    const filterTypeIsTillDate =
      filter.exprTypeTillDate &&
      (filter.userSelection.length === filter.rawselectmembers.length ||
        filter.userSelection.length === 0);
    if (filter.fieldtypeoption === 'Pick List') {
      return {
        fieldName: filter.fieldname,
        shouldExclude: filter.includeexclude === 'Exclude',
        dataType: filter.dataType,
        tableId: filter.tableId,
        isCalculatedField: filter.isCalculatedField ?? false,
        calculatedField: filter.calculatedField,
        filterOption: 'allValues',
        operator: filter.exprType ?? 'in',
        timeGrain: filter.prefix ?? 'year',
        userSelection:
          filter.userSelection && filter.userSelection.length > 0
            ? filter.userSelection[0] === '(All)'
              ? filter.userSelection.filter((opt) => opt !== '(All)')
              : filter.userSelection
            : undefined,
        currentSelection: filter.uId === lastModifiedFilter,
        ...(filter.filterTypeTillDate === 'enabled' ? { isTillDate: filter.exprTypeTillDate } : {}),
        filterType: filterTypeIsTillDate ? 'tillDate' : 'syncFilter',
      };
    } else if (filter.fieldtypeoption === 'Search Condition') {
      return {
        ...(filter.filterTypeTillDate === 'enabled' ? { isTillDate: filter.exprTypeTillDate } : {}),
        fieldName: filter.fieldname,
        dataType: filter.dataType,
        tableId: filter.tableId,
        isCalculatedField: filter.isCalculatedField ?? false,
        calculatedField: filter.calculatedField,
        filterOption: 'allValues',
        shouldExclude: filter.includeexclude === 'Exclude',
        operator: filter.exprType,
        timeGrain: filter.prefix ?? 'year',
        userSelection:
          filter.exprType === 'blank'
            ? []
            : filter.exprType === 'between' &&
                (filter.greaterThanOrEqualTo || filter.lessThanOrEqualTo)
              ? [filter.greaterThanOrEqualTo, filter.lessThanOrEqualTo]
              : filter.exprInput
                ? [filter.exprInput]
                : [],
        currentSelection: filter.uId === lastModifiedFilter,
        filterType: filterTypeIsTillDate ? 'tillDate' : 'syncFilter',
      };
    } else {
      return {
        fieldName: filter.fieldname,
        dataType: filter.dataType,
        tableId: filter.tableId,
        shouldExclude: filter.includeexclude === 'Exclude',
        isCalculatedField: filter.isCalculatedField ?? false,
        calculatedField: filter.calculatedField,
        filterOption: 'allValues',
        operator: filter.exprType,
        ...(filter.filterTypeTillDate === 'enabled' ? { isTillDate: filter.exprTypeTillDate } : {}),
        timeGrain: 'date',
        userSelection: [],
        currentSelection: filter.uId === lastModifiedFilter,
        filterType: 'relativeFilter',
        relativeCondition: {
          from: [
            filter.expTypeFromRelativeDate,
            filter.exprInputFromValueType,
            filter.expTypeFromdate,
          ],
          to: [filter.expTypeToRelativeDate, filter.exprInputToValueType, filter.expTypeTodate],
          anchorDate:
            filter.expTypeAnchorDate !== 'specificDate'
              ? filter.expTypeAnchorDate
              : filter.exprInputSpecificDate,
        },
      };
    }
  }

  return (
    <>
      {group && !group.isCollapsed ? (
        group.filters && group.filters.length ? null : (
          <p
            style={{
              fontSize: fontSize.extraSmall,
              color: color,
              textAlign: 'center',
              backgroundColor: 'red !important',
            }}
          >
            {fromDashboard ? 'No fields are there' : 'Please drag a field here'}
          </p>
        )
      ) : null}
      {!group.isCollapsed ? (
        <>
          {group &&
            group.filters?.map((field: fieldProps, index: number) => (
              <ChartFilterGroupCard
                propKey={
                  fromDashboard
                    ? `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`
                    : propKey
                }
                name={group.id}
                itemIndex={index}
                key={index}
                field={field}
                syncFilterEnabled={group.syncFilter}
                triggerSyncFilterDataFetch={syncFilterDataFetch}
                totalFiltersInGroup={group.filters.length}
                dsInfo={dsDetails}
                color={color}
                backgroundColor={backgroundColor}
              />
            ))}
        </>
      ) : null}
    </>
  );
};

const mapStateToProps = (
  state: ChartPropertiesStateProps & ChartFilterGroupStateProps & TileRibbonStateProps,
) => {
  return {
    chartProp: state.chartProperties,
    chartGroup: state.chartFilterGroup,
    calculations: state.calculations,
    tabState: state.tabState,
    tileState: state.tileState,
    tabTileProps: state.tabTileProps,
    dashBoardGroup: state.dashBoardFilterGroup,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    updateChartFilterGroupsFilters: (selectedDatasetID: string, groupId: string, filters: any) =>
      dispatch(updateChartFilterGroupsFilters(selectedDatasetID, groupId, filters)),
    updateChartFilterGroupsName: (groupId: string, name: string) =>
      dispatch(updateChartFilterGroupsName(groupId, name)),
    updateChartFilterGroupsCollapsed: (groupId: string, collapsed: boolean) =>
      dispatch(updateChartFilterGroupsCollapsed(groupId, collapsed)),
    updateDashBoardSelectedTabTiles: (groupId: string, selectedTabTiles: any) =>
      dispatch(updateDashBoardSelectedTabTiles(groupId, selectedTabTiles)),
    deleteDashBoardSelectedTabTiles: (groupId: string, groupIndex: number) =>
      dispatch(deleteDashBoardSelectedTabTiles(groupId, groupIndex)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FilterGroupContent);
